import { Component, Input } from '@angular/core';

@Component({
  selector: 'report-sql',
  template: `
    <span class="report-sql-toggle">
        <a href (click)="toggleSQL($event)">π</a>
      </span>
    <div class="report-sql-section" *ngIf="showSQL">
      <h3>SQL
        <copy-to-clipboard *ngIf="sqlModel" element=".report-sql-query" [statusMessage]="true"></copy-to-clipboard>
      </h3>
      <div class="code-section report-sql-query" contenteditable="true">{{ sqlModel }};<br/></div>
    </div>
  `
})
export class ReportSQLComponent {
  @Input() public sqlModel:string;

  public showSQL:boolean = false;

  public toggleSQL(event:Event):void {
    event.preventDefault();
    this.showSQL = !this.showSQL;
  }
}